import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiMap, FiFileText, FiCalendar } from 'react-icons/fi';
import FormWizard from '../../ui/FormWizard';
import { InputField, TextareaField } from '../../ui/InputField';

const DIAS = [
    { id: 0, label: 'Domingo' },
    { id: 1, label: 'Segunda-feira' },
    { id: 2, label: 'Terça-feira' },
    { id: 3, label: 'Quarta-feira' },
    { id: 4, label: 'Quinta-feira' },
    { id: 5, label: 'Sexta-feira' },
    { id: 6, label: 'Sábado' },
];

const CadastrarRotas = () => {
    const [sigla, setSigla] = useState('');
    const [descricao, setDescricao] = useState('');
    const [diasSemana, setDiasSemana] = useState([0, 0, 0, 0, 0, 0, 0]);
    const navigate = useNavigate();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const toggleDia = (id) => {
        const copy = [...diasSemana];
        copy[id] = copy[id] === 0 ? 1 : 0;
        setDiasSemana(copy);
    };

    const handleSubmit = () => {
        fetch(Apis.urlCadastrarRotas, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "nome": sigla, "descricao": descricao, "dias_semana_venda": diasSemana.join('') })
        }).then(r => r.json()).then(result => {
            if (result.retorno.sucesso) {
                navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-rotas`);
            } else {
                alertaErro(result.retorno.mensagem);
            }
        });
    };

    return (
        <FormWizard
            title="Cadastro de Rota"
            icon={<FiMap />}
            steps={['Dados da Rota', 'Dias de Funcionamento']}
            onSubmit={handleSubmit}
            submitLabel="Cadastrar"
        >
            {/* Passo 1 — Dados da Rota */}
            <>
                <InputField label="Nome da rota" icon={<FiMap />} required
                    placeholder="Nome da rota"
                    onChange={e => setSigla(e.target.value)} value={sigla} />
                <TextareaField label="Descrição" icon={<FiFileText />}
                    placeholder="Descrição da rota (opcional)"
                    onChange={e => setDescricao(e.target.value)} value={descricao} />
            </>

            {/* Passo 2 — Dias de Funcionamento */}
            <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <FiCalendar size={15} color="#1e3a4c" />
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#475569' }}>
                        Selecione os dias de funcionamento
                    </span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {DIAS.map(dia => {
                        const selected = diasSemana[dia.id] === 1;
                        return (
                            <button key={dia.id} type="button" onClick={() => toggleDia(dia.id)}
                                style={{
                                    padding: '11px 16px', borderRadius: 4, textAlign: 'left',
                                    border: `1.5px solid ${selected ? '#1e3a4c' : '#e2e8f0'}`,
                                    background: selected ? '#edf6fb' : '#fff',
                                    color: selected ? '#162e3c' : '#374151',
                                    fontWeight: selected ? 600 : 400,
                                    fontSize: 13, cursor: 'pointer', transition: 'all 0.15s',
                                    display: 'flex', alignItems: 'center', gap: 10,
                                }}>
                                <div style={{ width: 18, height: 18, borderRadius: 5, flexShrink: 0, border: selected ? 'none' : '2px solid #cbd5e1', background: selected ? 'linear-gradient(135deg, #3d7a9c, #1e3a4c)' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {selected && <span style={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>✓</span>}
                                </div>
                                {dia.label}
                            </button>
                        );
                    })}
                </div>
                <p style={{ fontSize: 11, color: '#94a3b8', margin: '4px 0 0' }}>
                    {diasSemana.filter(d => d === 1).length} dia(s) selecionado(s)
                </p>
            </>
        </FormWizard>
    );
};

export default CadastrarRotas;
